import React, { useState } from 'react';
import { VIDEOS } from '../data/mock';
import { Play } from 'lucide-react';

const VideoBlock = ({ v }) => {
  const [playing, setPlaying] = useState(false);
  return (
    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${v.reverse ? 'lg:[&>*:first-child]:order-2' : ''}`}>
      <div>
        <h3 className="heading-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{v.title}</h3>
        <p className="mt-6 text-slate-600 leading-8 text-[15px]">{v.body}</p>
      </div>
      <div className="relative aspect-video rounded-sm overflow-hidden shadow-xl bg-slate-900">
        {playing ? (
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${v.youtubeId}?autoplay=1&rel=0`}
            title={v.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button onClick={() => setPlaying(true)} className="absolute inset-0 w-full h-full group" aria-label="Play video">
            <img src={`https://img.youtube.com/vi/${v.youtubeId}/maxresdefault.jpg`} alt={v.title} className="w-full h-full object-cover" />
            <span className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors" />
            <span className="absolute inset-0 grid place-items-center">
              <span className="w-20 h-20 rounded-full bg-[#F97559] grid place-items-center text-white shadow-2xl transition-transform group-hover:scale-110">
                <Play size={32} fill="white" />
              </span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

const VideoSection = () => (
  <section className="py-20 md:py-24 bg-white">
    <div className="max-w-[1200px] mx-auto px-6 space-y-20">
      {VIDEOS.map((v, i) => <VideoBlock key={i} v={v} />)}
    </div>
  </section>
);

export default VideoSection;
